/* eslint-disable no-undef */
import { VRAsset } from './asset.js';
import { Node } from '../../../third-party/webxr/render/core/node.js';
import { Material } from '../../../third-party/webxr/render/core/material.js';
import { PrimitiveStream } from '../../../third-party/webxr/render/geometry/primitive-stream.js';
import { VRTooltip } from './tooltip.js';

export class VRHotspot extends VRAsset {
  static count = 0;

  static defaultOptions = {
    size: 32,
    color: '#5677FC',
    hoverColor: '#5677FC',
    borderColor: 'white',
    borderWidth: 2,
    messageBackgroundColor: 'white',
    messageTextColor: 'black',
    pulse: {
      enabled: true,
      width: 2,
      color: 'white'
    },
    icon: '00e',
    tooltip: { position: 'top', label: '', displayType: 'hover' }
  };

  constructor (vr, scene, options) {
    super(vr, scene, $.extend({}, VRHotspot.defaultOptions, options));
    this.vr = vr;
    this.count = VRHotspot.count;

    if (!this.options.id || this.options.id === undefined) {
      this.options.id = 'hotspot_' + this.count;
    }
    if (this.options.action !== undefined) {
      this.appendActionLinkToHotspot(this.options.action);
    }

    if (options === undefined) {
      this.options.tooltip.label = '';
    }

    this.div.addClass('ca-vr_hotspot');
    this.div.addClass('ca-vr_hotspot' + this.count);

    this.dot = $('<div class="ca-vr_hotspot_dot"></div>');
    this.dot.css('border-color', this.options.borderColor);
    this.dot.css('border-width', this.options.borderWidth);
    this.assetContainer.append(this.dot);

    if (!this.vr.options.mobile) {
      this.pulse = $('<div class="ca-vr_hotspot_pulse"></div>');
      this.pulse.css('border-color', this.options.pulse.color);
      this.pulse.css('border-width', this.options.pulse.width);
      this.assetContainer.append(this.pulse);
    }

    this.svgIcon = $(
      '<svg class="ca-vr_hotspot_svgicon" viewBox="0 0 28 28"><text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" fill="white">&#xf00e;</text></svg>'
    );
    this.dot.append(this.svgIcon);

    this.tooltip = new VRTooltip(this.options.tooltip);
    this.div.append(this.tooltip.div);
    this.positionTooltip();

    if (this.options.tooltip.displayType === undefined) {
      this.options.tooltip.displayType = 'hover';
    }

    if (this.tooltip.options.label) {
      this.options.tooltip.label = this.tooltip.options.label;
    }

    this.setTooltip(this.options.tooltip);
    this.setTooltipDisplayType(this.options.tooltip.displayType);
    this.setIcon(this.options.icon);
    this.setSize(this.options.size);
    this.setColor(this.options.color);
    this.setHoverColor(this.options.hoverColor);
    this.setMessageBackgroundColor(this.options.messageBackgroundColor);
    this.setMessageTextColor(this.options.messageTextColor);

    if (!this.vr.options.mobile) {
      this.setPulse(this.options.pulse.enabled);
    }

    VRHotspot.count++;

    this.div.on(
      'click',
      function () {
        vr.hotspotClicked(this.getYaw(), this.getPitch());
        if (!this.vr.isEditing()) {
          this.executeAction();
        }
      }.bind(this)
    );

    this.div.on('mouseover', function () {
      if (!vr.isEditing()) {
        this.toggleTooltipVisibility(true);
        this.toggleHoverColor(true);
      }
    }.bind(this));

    this.div.on('mouseleave', function () {
      if (!vr.isEditing()) {
        this.toggleTooltipVisibility(false);
        this.toggleHoverColor(false);
      }
    }.bind(this));
  }

  sendActionToMatomo (hotspot, objectType, eventType, data) {
    if (typeof _paq !== 'undefined' && _paq !== null) {
      _paq.push(['trackEvent', objectType, eventType, data]);
    }
  }

  positionTooltip () {
    if (!this.options.tooltip) return;

    const pos = this.options.tooltip.position;
    // const pos = 'top';
    if (pos === 'top') {
      this.tooltip.div.css(
        'transform',
        'translate(-50%, calc(-100% - ' + this.options.size / 2 + 'px))'
      );
    } else if (pos === 'bottom') {
      this.tooltip.div.css(
        'transform',
        'translate(-50%, ' + this.options.size / 2 + 'px)'
      );
    } else if (pos === 'right') {
      this.tooltip.div.css(
        'transform',
        'translate(' + this.options.size / 2 + 'px, -50%)'
      );
    } else if (pos === 'left') {
      this.tooltip.div.css(
        'transform',
        'translate(calc(-100% - ' + this.options.size / 2 + 'px), -50%)'
      );
    }
  }

  setTooltip (tooltip) {
    // console.log('Set tool tip called');
    // console.log(tooltip);
    if (!tooltip) return;
    this.setTooltipText(tooltip.label);
    // do set tooltip position here?
  }

  setTooltipText (tooltipText) {
    // console.log('set tooltip text called');
    // console.log(tooltipText);
    if (this.options.tooltip === undefined) {
      this.options.tooltip = {
        position: 'top',
        label: tooltipText
      };
      this.options.tooltip.label = tooltipText;
    } else {
      this.options.tooltip.label = tooltipText;
    }
    // console.log(this.options.tooltip.label);
    this.tooltip.setText(this.options.tooltip.label);
    // this.overlayHeading.text(this.say);
  }

  getTooltipText () {
    return this.tooltip.options.label;
  }

  setTooltipPosition (tooltipPosition) {
    this.options.tooltip.position = tooltipPosition;
    this.tooltip.setPosition(tooltipPosition);
    this.positionTooltip();
  }

  getTooltipPosition () {
    return this.options.tooltip.position;
  }

  setTooltipDisplayType (tooltipDisplayType) {
    // console.log('set tooltip display type', tooltipDisplayType);
    this.options.tooltip.displayType = tooltipDisplayType;
  }

  getTooltipDisplayType () {
    console.log('get tooltip display type', this.options.tooltip.displayType);
    return this.options.tooltip.displayType;
  }

  toggleTooltipVisibility (isTooltipVisible) {
    if (this.options.tooltip.displayType === 'hover') {
      if (isTooltipVisible) {
        this.tooltip.tooltipLabel.show();
        this.tooltip.tooltipBg.show();
      } else {
        this.tooltip.tooltipLabel.hide();
        this.tooltip.tooltipBg.hide();
      }
    } else if (this.options.tooltip.displayType === 'never') {
      this.tooltip.tooltipLabel.hide();
      this.tooltip.tooltipBg.hide();
    }
  }

  toggleHoverColor (enableHoverColor) {
    if (enableHoverColor) {
      this.dot.css('background-color', this.options.hoverColor);
    } else {
      this.dot.css('background-color', this.options.color);
    }
  }

  setEditMode (editMode) {
    this.div.toggleClass('edit', editMode);
    if (editMode) this.vr.getEditor().openSubPanel(this);
    else this.vr.getEditor().closeSubPanel();
  }

  setSize (size) {
    this.options.size = size;
    this.width = size;
    this.height = size;
    this.dot.css('width', size);
    this.dot.css('height', size);
    this.assetContainer.css('left', -(size / 2 + 20));
    this.assetContainer.css('top', -(size / 2 + 20));
    // this.svgIcon.attr('viewBox', '0 0 '+size+' '+size);

    this.positionTooltip();
  }

  getSize () {
    return this.options.size;
  }

  setIcon (icon, iconName) {
    this.options.icon = icon;
    this.options.iconName = iconName;
    this.svgIcon.find('text').html(icon ? '&#xf' + icon + ';' : '');
  }

  getJsonConfig () {
    // const config = Object.assign({}, this.options);
    // console.log(config);
    // return config;
    return this.options;
  }

  getIcon () {
    return this.options.icon;
  }

  setColor (color) {
    this.options.color = color;
    this.dot.css('background-color', color);
  }

  getColor () {
    return this.options.color;
  }

  setHoverColor (color) {
    this.options.hoverColor = color;
  }

  getHoverColor () {
    return this.options.hoverColor;
  }

  setMessageBackgroundColor (color) {
    this.options.messageBackgroundColor = color;
    // call tooltip background color here
    this.tooltip.setBackgroundColor(color);
  }

  getMessageBackgroundColor () {
    return this.options.messageBackgroundColor;
  }

  setMessageTextColor (color) {
    this.options.messageTextColor = color;
    this.tooltip.setTextColor(color);
  }

  getMessageTextColor () {
    return this.options.messageTextColor;
  }

  setPulse (pulse) {
    this.options.pulse.enabled = pulse;
    this.pulse.toggle(pulse);
  }

  getPulse () {
    return this.options.pulse.enabled;
  }

  getAction () {
    return this.options.action;
  }

  setAction (action) {
    // set the action option to the action argument
    if (this.options.action !== undefined) {
      this.options.action = {};
    }
    this.options.action = action;
  }

  appendActionLinkToHotspot (action) {
    // console.log('append action link to hotspot');
    // console.log(action);
    if (action.type === 'popup') {
      // console.log('this shouldnt be hitting the popup use case');
      this.assetContainer.children('.ca-vr_action-link').remove();
      this.actionLink = $(`<div class='ca-vr_action-link'><a href='javascript:;' data-modal-uuid='${action.actionInfo.popupId}'></a></div>`);
      this.assetContainer.append(this.actionLink);
      this.setAction(action);
    } else if (action.type === 'url') {
      this.assetContainer.children('.ca-vr_action-link').remove();
      this.actionLink = $(`<div class='ca-vr_action-link'><a href='${action.actionInfo.urlToVisit}' ${action.actionInfo.openInNewTab === true ? 'target="_blank"' : ''}></a></div>`);
      this.assetContainer.append(this.actionLink);
      this.setAction(action);
    } else if (action.type === 'download') {
      this.assetContainer.children('.ca-vr_action-link').remove();
      this.actionLink = $(`<div class='ca-vr_action-link'><a href='${action.actionInfo.assetLink}' download'></a></div>`);
      this.assetContainer.append(this.actionLink);
      this.setAction();
    } else if (action.type === 'media') {
      this.assetContainer.children('.ca-vr_action-link').remove();
      console.log('should be hitting this in the media if case');
      this.actionLink = $(`<div class='ca-vr_action-link'><a href='javascript:;' data-modal-media-uuid='${action.actionInfo.mediaUUID}'></a></div>`);
      this.assetContainer.append(this.actionLink);
      this.setAction(action);
    }

    if (this.actionLink !== undefined) {
      this.actionLink.on('mouseover', function (event) {
        if (this.vr !== undefined && this.vr.isEditing()) {
          event.stopPropagation();
          this.actionLink.addClass('disabled-in-editor');
        } else if (!this.vr.isEditing()) {
          this.actionLink.removeClass('disabled-in-editor');
        }
      }.bind(this));
    }
  }

  executeAction () {
    console.log('execute action called');
    // should call this when the hotspot is clicked on
    // but only if the editor isnt open
    if (!this.vr.isEditing()) {
      console.log('vr is currently not editing');
      console.log(this.options.action);
      if (this.options.action !== undefined) {
        if (this.options.action.type === 'url') {
          if (!this.options.action.actionInfo.urlToVisit.match(/^https?:\/\//i)) {
            this.options.action.actionInfo.urlToVisit =
              'https://' + this.options.action.actionInfo.urlToVisit;
          }
          if (this.options.action.actionInfo.openInNewTab) {
            window.open(`${this.options.action.actionInfo.urlToVisit}`, '_blank');
          } else {
            window.open(
              `${this.options.action.actionInfo.urlToVisit}`,
              '_parent'
            );
          }
        } else if (this.options.action.type === 'download') {
          window.open(this.options.action.actionInfo.assetLink);
          const documentTitle = this.options.action.actionInfo.assetData.title;
          this.sendActionToMatomo(this, 'Download', 'Document', documentTitle !== undefined ? documentTitle : this.options.tooltip.label !== undefined ? this.options.tooltip.label : 'Unknown');
        } else if (this.options.action.type === 'popup') {
          const modalTitle = this.options.action.actionInfo.content.data.name;
          if (this.vr.editor !== undefined) {
            this.displayPopupInEditor(this.options.action.actionInfo.popupId);
          }
          this.sendActionToMatomo(this, 'popup', 'ajax', modalTitle !== undefined ? modalTitle : this.options.tooltip.label !== undefined ? this.options.tooltip.label : 'Unknown');
          console.log(this.options.action.actionInfo.content);
          if (this.options.action.actionInfo.content.data.metadata.children[0].props.media !== undefined && this.options.action.actionInfo.content.data.metadata.children[0].props.media !== null && this.options.action.actionInfo.content.data.metadata.children[0].props.media.type === 'video') {
            const videoTitle = this.options.action.actionInfo.content.data.metadata.children[0].props.media.title;
            this.sendActionToMatomo(this, 'Video', 'video played', videoTitle !== undefined ? videoTitle : modalTitle !== undefined ? modalTitle : this.options.tooltip.label !== undefined ? this.options.tooltip.label : 'Unknown');
          }
        } else if (this.options.action.type === 'jumpToScene') {
          this.vr.lookAtOverlay(this, this.vr.getMaxFov(), 400, true);
          this.vr.loadScene(this.options.action.scene, -this.options.yaw, this.options.pitch);
        }
      }

      this.sendActionToMatomo(this, 'Hotspot', 'Hotspot click', this.options.tooltip.label ? this.options.tooltip.label : 'Unknown');
    }
  }

  displayPopupInEditor (popupId) {
    console.log('display popup in editor called');
    const url = `https://caportal.com.au/cms/${popupId}?context=ver-editor`;
    this.currentPopupIframe = $(`<iframe src=${url} class="ca-vr-editor_view-popup"></iframe>`);
    this.vr.container.append(this.currentPopupIframe);
    this.vr.editor.currentPreviewPopup = this.currentPopupIframe;
    this.vr.editor.setShowPopupPreview(true);
  }

  onFirstRender () {
    this.tooltip.layout();
  }

  render (t) {
    if (!super.render(t)) return;

    /* this.position = this.vr.yawPitchToPx(this.options.yaw, this.options.pitch);
        if(this.position != undefined && this.vr.isInView(this.options.yaw, this.options.pitch))
        {
            this.div.css('left', this.position.x);
            this.div.css('top', this.position.y);
        }
        else this.div.css('left', -1000); */

    const bottomRight = this.vr.yawPitchToPx(
      this.options.yaw + 10,
      this.options.pitch + 10
    );
    if (bottomRight.x < 0) {
      this.setValidTransform(false);
      return false;
    }

    const validCoords = this.topLeft !== undefined;
    const validPitch = this.topLeft.y > bottomRight.y;

    if (validCoords && validPitch) {
      this.setValidTransform(true);
      // this.div.css('left', Math.ceil(this.topLeft.x));
      // this.div.css('top', Math.ceil(this.topLeft.y));

      this.div[0].style.transform =
        'translate(' +
        Math.ceil(this.topLeft.x) +
        'px, ' +
        Math.ceil(this.topLeft.y) +
        'px)';
    } else this.setValidTransform(false);
  }

  mousemove (event) {
    if (!this.moving) return;
    this.moveBy(
      (this.startX - event.clientX) / 10,
      (this.startY - event.clientY) / 10
    );
  }

  moveBy (x, y) {
    super.moveBy(x, y);
    this.move(
      this.mouseDownTopLeftYawPitch.yaw - x,
      this.mouseDownTopLeftYawPitch.pitch + y
    );
  }

  setType (type) {
    this.options.type = type;
    this.div.addClass('ca-vr_hotspot_' + type);
  }

  getType () {
    return this.options.type;
  }

  show () {
    this.div.removeClass('ca-vr_hotspot-hidden');
  }

  hide () {
    this.div.addClass('ca-vr_hotspot-hidden');
  }

  getYaw () {
    return -this.topLeftYawPitch.yaw;
  }

  getPitch () {
    return this.topLeftYawPitch.pitch;
  }
}

export class VRIconHotspot extends VRHotspot {
  constructor (vr, scene, options) {
    super(vr, scene, options);

    super.setType('icon');

    this.mouseOver = false;
    this.clicked = false;
  }
}

export class VRSceneJumpHotspot extends VRHotspot {
  constructor (vr, scene, options) {
    super(vr, scene, options);

    super.setType('scenejump');

    this.mouseOver = false;
    this.clicked = false;

    this.div.on(
      'click',
      function () {
        this.clicked = true;
        // this is olllld
        this.vr.loadScene(
          this.options.jumpToScene,
          -this.options.yaw,
          this.options.pitch
        );
      }.bind(this)
    );
  }
}

const BUTTON_SIZE = 0.1;
const BUTTON_CORNER_RADIUS = 0.05;
const BUTTON_CORNER_SEGMENTS = 8;
const BUTTON_LAYER_DISTANCE = 0.005;
const BUTTON_COLOR = 0.75;
const BUTTON_ALPHA = 0.85;
const BUTTON_HOVER_COLOR = 0.9;
const BUTTON_HOVER_ALPHA = 1.0;
const BUTTON_HOVER_SCALE = 1.1;
const BUTTON_HOVER_TRANSITION_TIME_MS = 200;

class ButtonMaterial extends Material {
  constructor () {
    super();

    this.state.blend = true;

    this.defineUniform('hoverAmount', 0);
  }

  get materialName () {
    return 'BUTTON_MATERIAL';
  }

  get vertexSource () {
    return `
    attribute vec3 POSITION;

    uniform float hoverAmount;

    vec4 vertex_main(mat4 proj, mat4 view, mat4 model) {
      float scale = mix(1.0, ${BUTTON_HOVER_SCALE}, hoverAmount);
      vec4 pos = vec4(POSITION.x * scale, POSITION.y * scale, POSITION.z * (scale + (hoverAmount * 0.2)), 1.0);
      return proj * view * model * pos;
    }`;
  }

  get fragmentSource () {
    return `
    uniform float hoverAmount;

    const vec4 default_color = vec4(${BUTTON_COLOR}, ${BUTTON_COLOR}, ${BUTTON_COLOR}, ${BUTTON_ALPHA});
    const vec4 hover_color = vec4(${BUTTON_HOVER_COLOR}, ${BUTTON_HOVER_COLOR},
                                  ${BUTTON_HOVER_COLOR}, ${BUTTON_HOVER_ALPHA});

    vec4 fragment_main() {
      return mix(default_color, hover_color, hoverAmount);
    }`;
  }
}

export class HotspotNode extends Node {
  constructor (callback) {
    super();

    this.selectable = true;

    this._selectHandler = callback;
    this._hovered = false;
    this._hoverT = 0;
  }

  onRendererChanged (renderer) {
    const stream = new PrimitiveStream();

    const hd = BUTTON_LAYER_DISTANCE * 0.5;

    // Build a rounded rect for the background.
    const hs = BUTTON_SIZE * 0.5;
    const ihs = hs - BUTTON_CORNER_RADIUS;
    stream.startGeometry();

    // Rounded corners and sides
    const segments = BUTTON_CORNER_SEGMENTS * 4;
    for (let i = 0; i < segments; ++i) {
      const rad = i * ((Math.PI * 2.0) / segments);
      let x = Math.cos(rad) * BUTTON_CORNER_RADIUS;
      let y = Math.sin(rad) * BUTTON_CORNER_RADIUS;
      const section = Math.floor(i / BUTTON_CORNER_SEGMENTS);
      switch (section) {
        case 0:
          x += ihs;
          y += ihs;
          break;
        case 1:
          x -= ihs;
          y += ihs;
          break;
        case 2:
          x -= ihs;
          y -= ihs;
          break;
        case 3:
          x += ihs;
          y -= ihs;
          break;
      }

      stream.pushVertex(x, y, -hd, 0, 0, 0, 0, 1);

      if (i > 1) {
        stream.pushTriangle(0, i - 1, i);
      }
    }

    stream.endGeometry();

    const buttonPrimitive = stream.finishPrimitive(renderer);
    this._buttonRenderPrimitive = renderer.createRenderPrimitive(
      buttonPrimitive,
      new ButtonMaterial()
    );
    this.addRenderPrimitive(this._buttonRenderPrimitive);
  }

  onHoverStart () {
    this._hovered = true;
  }

  onHoverEnd () {
    this._hovered = false;
  }

  _updateHoverState () {
    const t = this._hoverT / BUTTON_HOVER_TRANSITION_TIME_MS;
    // Cubic Ease In/Out
    // TODO: Get a better animation system
    const hoverAmount =
      t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    this._buttonRenderPrimitive.uniforms.hoverAmount.value = hoverAmount;
  }

  onUpdate (timestamp, frameDelta) {
    if (this._hovered && this._hoverT < BUTTON_HOVER_TRANSITION_TIME_MS) {
      this._hoverT = Math.min(
        BUTTON_HOVER_TRANSITION_TIME_MS,
        this._hoverT + frameDelta
      );
      this._updateHoverState();
    } else if (!this._hovered && this._hoverT > 0) {
      this._hoverT = Math.max(0.0, this._hoverT - frameDelta);
      this._updateHoverState();
    }
  }
}
